import { Icon, Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { TypographyPropsVariantOverrides } from '@mui/material/Typography/Typography';
import { OverridableStringUnion } from '@mui/types';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { COLOR } from '@/globalStyles';
import { normalizeDateForUI } from '@/utils/date/date';

type RequestApproverProps = {
    className?: string;
    icon?: string;
    iconColor?: string;
    children?: ReactNode;
    iconSize?: string;
};

const RequestApprover = ({ className, icon, iconColor, children, iconSize = '1.5rem' }: RequestApproverProps) => {
    return (
        <div className={className}>
            <Icon sx={{ color: iconColor, fontSize: iconSize }}>{icon}</Icon>
            <ApproverWrapper>{children}</ApproverWrapper>
        </div>
    );
};

export const ApproverTitle = styled(
    ({
        title,
        textVariant = 'table_text',
    }: {
        title: string;
        textVariant?: OverridableStringUnion<'inherit' | Variant, TypographyPropsVariantOverrides>;
    }) => {
        const { t } = useTranslation();
        return (
            <Typography variant={textVariant} color={COLOR.zambezi}>
                {t(title)}
            </Typography>
        );
    }
)``;

export const ApprovedBy = styled(
    ({
        name,
        textVariant = 'created_by',
    }: {
        name: string;
        textVariant?: OverridableStringUnion<'inherit' | Variant, TypographyPropsVariantOverrides>;
    }) => {
        const { t } = useTranslation();
        return name ? (
            <Typography variant={textVariant} color={COLOR.zambezi}>
                {t('translation_by')} {name}
            </Typography>
        ) : null;
    }
)``;

export const ApprovalDate = styled(
    ({
        date,
        textVariant = 'created_by',
    }: {
        date: string | number | Date;
        textVariant?: OverridableStringUnion<'inherit' | Variant, TypographyPropsVariantOverrides>;
    }) => {
        const { t } = useTranslation();
        return (
            <Typography variant={textVariant} color={COLOR.zambezi}>
                {t('coworkersFiltersView_date_title')}: {normalizeDateForUI(new Date(date))}
            </Typography>
        );
    }
)``;

const ApproverWrapper = styled.div`
    display: flex;
    flex-direction: column;
    & > span:last-of-type {
        margin-top: 0.2rem;
    }
`;

const Styled = styled(RequestApprover)``;
export default Styled;
